import logo from '../logo.svg';
import Experience from './Experience';
import React from "react";
import {useEffect} from "react"
import LeftSide from './LeftSide';
import Rightside from './Rightside';
import {motion } from 'framer-motion'
const About = ()=> {

    useEffect(() => {
       
        window.scrollTo(0, 0);
      }, []);

    return (

        <div id="about" className='flex px-[10%]'>
          <div> 

{/* <div id="about" className='items-center justify-center flex flex-wrap z-10 min-h-screen'> */}
<div className="flex flex-col items-start bg-navy z-1 pt-[5%] pb-[5%] h-screen "  >
  
  <div className="bg-navy text-slate text-lg max-w-[70%]  text-left">

  <h2 className="flex flex-col flex-wrap text-md sm:text-sm md:text-xl lg:text-2xl xl:text-3xl font-bold text-lightestslate text-left pt-[1%] pb-[1%]">About Me</h2>
    <motion.p  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.3}}  className=" text-md sm:text-xs md:text-sm lg:text-md xl:text-lg pb-[2%]">
      Hello! I'm Sai Charan, a web enthusiast weaving digital wonders since 2013. 
      My journey began with the curiosity of the Inspect button. Fast-forward to today, I've had the privilege of working at an <span className='text-green'>early-stage start-up,
      a huge corporation, and student-led organizations</span>
    </motion.p>

    <motion.p  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.4}}  className="text-md sm:text-xs md:text-sm lg:text-md xl:text-lg  pb-[2%]">
      Currently, my passion lies in crafting inclusive digital experiences and architecting cloud solutions for a variety of clients.
    </motion.p>

    <motion.p  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.5}}  className=" text-md sm:text-xs md:text-sm lg:text-md xl:text-lg  pb-[2%]">
      Here are a few technologies I've been working with recently:    </motion.p>
     
  </div>

  <div className=' max-w-[100%]'>
        <ul className='grid grid-rows-3 grid-cols-2  pb-[2%]'>

        <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.6}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className=' p-2 m-2 text-green'>Java Spring Boot</span>
      </motion.li>


      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.6}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className=' p-2 m-2 text-green'>Kafka</span>
      </motion.li>


      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>FastAPI</span>
      </motion.li>

        <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.6}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className=' p-2 m-2 text-green'>React</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.7}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Node.js</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.8}} > 
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Express.js</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.9}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>JavaScript</span>

      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.0}} >
      <i className="fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Java</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Python</span>
      </motion.li>


      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Django</span>
      </motion.li>


      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>AWS</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>GCP</span>
      </motion.li>

      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Terraform</span>
      </motion.li>
      <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} >
      <i className =" fa fa-arrow-right text-green"></i>
     
      <span className='p-2 m-2 text-green'>Kubernetes</span>
      </motion.li>
      </ul>
      </div>




</div>




{/* </div> */}
<motion.div initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.3}}  className="hidden xl:inline-flex w-32 h-full fixed right-0 bottom-[0%]">
        <Rightside/>
    </motion.div>

    <motion.div  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.3}} className="hidden xl:inline-flex w-32 h-full fixed left-0 bottom-[0%]">
        <LeftSide/>
    </motion.div>

    {/* <div className='hidden  md:flex w-full max-w-[40%] max-h-[10%] relative group right-[10%] '>
 <div className='absolute w-full max-h-[10%] right-10 top-6 rounded-lg'>
   <div className='w-full h-full relative z-1 flex pl-6 lg:pl-0'>
     <img  alt="profile_pic" src={logo} className='rounded-lg h-full object-cover'></img>
   </div>
 </div>
</div> */}
 


</div>

</div>
    )
}

export default About;